import React from 'react';

const getStatusColor = (status) => {
  switch (status) {
    case 'PENDING_CONFIRMATION': return { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'در انتظار تأیید' };
    case 'PREPARING': return { bg: 'bg-blue-100', text: 'text-blue-800', label: 'در انتظار آماده سازی' };
    case 'PARTIALLY_SHIPPED': return { bg: 'bg-blue-100', text: 'text-blue-800', label: 'بخشی در حمل' };
    case 'SHIPPED': return { bg: 'bg-blue-100', text: 'text-blue-800', label: 'در حمل' };
    case 'PARTIALLY_DELIVERED': return { bg: 'bg-blue-100', text: 'text-blue-800', label: 'بخشی تحویل شده' };
    case 'DELIVERED': return { bg: 'bg-green-100', text: 'text-green-800', label: 'تحویل شده' };
    case 'CANCELLED': return { bg: 'bg-red-100', text: 'text-red-800', label: 'لغو شده' };
    case 'RETURNED': return { bg: 'bg-purple-100', text: 'text-purple-800', label: 'مرجوع شده' };
    default: return { bg: 'bg-gray-100', text: 'text-gray-800', label: 'نامشخص' };
  }
};

const OrderStatusBadge = ({ status }) => {
  const { bg, text, label } = getStatusColor(status);

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${bg} ${text}`}>
      {label}
    </span>
  );
};

export default OrderStatusBadge;
